import React from 'react';
import { portfolioData } from '../mock';

const Skills = () => {
  return (
    <section className="py-32 bg-black border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-20">
          <span className="text-sm tracking-[0.3em] text-zinc-500 uppercase font-medium mb-4 block">
            Expertise
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-white tracking-tight">
            Skills
          </h2>
        </div>

        {/* Skills List - Clean minimal design */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-2">
          {portfolioData.skills.map((skill, index) => (
            <div
              key={skill}
              className="group py-6 border-b border-zinc-900 hover:border-zinc-700 transition-colors"
              style={{
                animation: `fade-in-up 0.6s ease-out ${index * 0.08}s both`
              }}
            >
              <div className="flex items-baseline gap-4">
                <span className="text-sm text-zinc-600 font-mono">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors">
                  {skill}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
